export interface LStorageConfig {
  namespace: string;
  ttl?: number;
}

export type StoredValue = number | string | object | null;

const defaultConfig: LStorageConfig = {
  namespace: 'coyote-web',
  ttl: undefined,
};

class LStorage {
  defaultConfig = defaultConfig;

  constructor(config: LStorageConfig) {
    this.defaultConfig = config;
  }

  getNamespaceKey(key: string): string {
    return `${this.defaultConfig.namespace}-${key}`;
  }

  get(key: string): StoredValue {
    try {
      const storage = localStorage.getItem(this.getNamespaceKey(key));

      if (!storage) {
        return null;
      }

      const { meta, storedValue } = JSON.parse(storage);
      const { ttl, createdAt } = meta;

      if (ttl && Date.now() > ttl + createdAt) {
        return null;
      }

      return storedValue;
    } catch (e) {
      console.error(`Unable to parse stored value. key=${key}`, e);
      return null;
    }
  }

  set(key: string, storedValue: StoredValue, ttl?: number): void {
    try {
      localStorage.setItem(
        this.getNamespaceKey(key),
        JSON.stringify({
          meta: {
            ttl: ttl || null,
            createdAt: Date.now(),
          },
          storedValue,
        })
      );
    } catch (e) {
      console.error(
        `Unable to store value in local storage: key=${key}`,
        e,
        storedValue
      );
    }
  }

  removeItem(key: string): void {
    localStorage.removeItem(this.getNamespaceKey(key));
  }

  clearNamespace(): void {
    // TODO
  }
}

export { LStorage };
export default new LStorage(defaultConfig);
